import { AchievementsEducationLevel, AchievementsExperience } from 'main/gql/globalTypes'

interface IManifest {
  education: {
    imageUrls: { [key in AchievementsEducationLevel]: string }
  }
  infantToddler: {
    imageUrls: { [key in AchievementsExperience]: string }
  }
  preschool: {
    imageUrls: { [key in AchievementsExperience]: string }
  }
  school: {
    imageUrls: { [key in AchievementsExperience]: string }
  }
  specialCertifications: {
    imageUrls: string[]
  }
}

const manifest: IManifest = {
  education: {
    imageUrls: {
      [AchievementsEducationLevel.SIX_PLUS_CREDITS]:
        'https://ucarecdn.com/6f3fb957-face-4da5-bcf4-610facab5ef5/',
      [AchievementsEducationLevel.TWELVE_PLUS_CREDITS]:
        'https://ucarecdn.com/5e2cb73f-f937-4767-b94f-310a6dd0b3fc/',
      [AchievementsEducationLevel.EIGHTEEN_PLUS_CREDITS]:
        'https://ucarecdn.com/08c2c33b-7516-4dbe-9a23-1187b60aed78/',
      [AchievementsEducationLevel.ASSOCIATES_DEGREE]:
        'https://ucarecdn.com/5d1a047f-9e82-4ed3-8882-d4fdf6da5105/',
      [AchievementsEducationLevel.BACHELORS_DEGREE]:
        'https://ucarecdn.com/f3f55ced-83b0-4dbe-9b3a-a293d87da462/',
      [AchievementsEducationLevel.MASTERS_DEGREE]:
        'https://ucarecdn.com/1d89208f-2b76-427e-80a1-b76b4fa5b28c/',
    },
  },
  infantToddler: {
    imageUrls: {
      [AchievementsExperience.ONE_PLUS_YEAR]:
        'https://ucarecdn.com/10a8ec6b-5c5d-4bf4-a83b-765a256ea586/',
      [AchievementsExperience.TWO_PLUS_YEARS]:
        'https://ucarecdn.com/ee9e2aef-38e0-4fd2-971f-f55f51a0e8ec/',
      [AchievementsExperience.THREE_PLUS_YEARS]:
        'https://ucarecdn.com/1c053762-db99-4c06-aef3-b0ba71f4d8dd/',
      [AchievementsExperience.FOUR_PLUS_YEARS]:
        'https://ucarecdn.com/8d6d3635-fe9a-482a-b956-2dd3c2130a28/',
      [AchievementsExperience.FIVE_PLUS_YEARS]:
        'https://ucarecdn.com/e7d999a4-869d-4f78-a65d-1de1700cd9fb/',
      [AchievementsExperience.TEN_PLUS_YEARS]:
        'https://ucarecdn.com/b9e40ed8-2ea3-47a7-b5dd-4f40d98e7ce6/',
      [AchievementsExperience.FIFTEEN_PLUS_YEARS]:
        'https://ucarecdn.com/14b87b2b-bd62-450c-922d-d2b6559fce2b/',
      [AchievementsExperience.TWENTY_PLUS_YEARS]:
        'https://ucarecdn.com/deaacaa3-52fd-4b14-960e-323bf0b3823c/',
    },
  },
  preschool: {
    imageUrls: {
      [AchievementsExperience.ONE_PLUS_YEAR]:
        'https://ucarecdn.com/75a83d2a-3883-476e-8d7e-2f903239a467/',
      [AchievementsExperience.TWO_PLUS_YEARS]:
        'https://ucarecdn.com/fb97aec0-f120-4f22-9f2f-e4c81566dc24/',
      [AchievementsExperience.THREE_PLUS_YEARS]:
        'https://ucarecdn.com/97af9d87-66f4-4b13-b9e3-827f3a909215/',
      [AchievementsExperience.FOUR_PLUS_YEARS]:
        'https://ucarecdn.com/17e21071-0417-487d-92b3-16bff44ca491/',
      [AchievementsExperience.FIVE_PLUS_YEARS]:
        'https://ucarecdn.com/e7011484-f475-4303-9706-c6fe986d1f66/',
      [AchievementsExperience.TEN_PLUS_YEARS]:
        'https://ucarecdn.com/5386a6cb-6287-4f83-9d46-fdd46105523f/',
      [AchievementsExperience.FIFTEEN_PLUS_YEARS]:
        'https://ucarecdn.com/6789e97a-f562-4dc2-b81b-d0a28b169024/',
      [AchievementsExperience.TWENTY_PLUS_YEARS]:
        'https://ucarecdn.com/1ae79840-7c50-496b-9af8-e28abc369a08/',
    },
  },
  school: {
    imageUrls: {
      [AchievementsExperience.ONE_PLUS_YEAR]:
        'https://ucarecdn.com/138907d3-022a-4047-a460-1ae65f218c4c/',
      [AchievementsExperience.TWO_PLUS_YEARS]:
        'https://ucarecdn.com/5289b6ce-a96b-4ca7-aeb7-d5aa1f9eabd4/',
      [AchievementsExperience.THREE_PLUS_YEARS]:
        'https://ucarecdn.com/aa056b98-6d18-4c4c-a1d5-61e7c79d4d84/',
      [AchievementsExperience.FOUR_PLUS_YEARS]:
        'https://ucarecdn.com/77285e02-2c84-413d-9758-b4395ba6b0f9/',
      [AchievementsExperience.FIVE_PLUS_YEARS]:
        'https://ucarecdn.com/62e6c60d-1a3d-4945-87d6-045a9da9caa1/',
      [AchievementsExperience.TEN_PLUS_YEARS]:
        'https://ucarecdn.com/f127dae7-1c79-43d2-9e1a-84b822fdd64f/',
      [AchievementsExperience.FIFTEEN_PLUS_YEARS]:
        'https://ucarecdn.com/23bc28c6-230d-411e-8548-cff3505ba350/',
      [AchievementsExperience.TWENTY_PLUS_YEARS]:
        'https://ucarecdn.com/5047ca65-c555-4eff-b696-6ba9bbd1b8aa/',
    },
  },
  specialCertifications: {
    imageUrls: [
      'https://ucarecdn.com/1f8d95a7-d392-43d9-8ad0-716a7ec5db45/',
      'https://ucarecdn.com/6db4f55f-80fa-4297-ab1a-343863c24816/',
      'https://ucarecdn.com/0bdc7da4-ad16-4b05-b087-d4af51c65126/',
    ],
  },
}

export default manifest
